import { Card, Row, Spin } from "antd"
import { EnquiryRes } from "../../../../response/enquiry.response"
import theme from "antd/lib/theme"
import Table, { ColumnsType } from "antd/es/table"
import { TextEditorView } from "../../../../view/text-editor.view"
import { Link, useNavigate } from "react-router-dom"
import React from "react"
import { PropertyPrefrence } from "./requirement/property-prefrences.component"
import { LocationPreference } from "./requirement/location-pref.component"
import { EnquiryStatus } from "./requirement/enquiry-status.component"
import { EnquireRowReadItem } from "./enquiry-row-read-item.component"
import { formatName } from "../../../../util/name-helper"

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export interface RequirementDetailComponentProps {
    enquiry: EnquiryRes
    oldEnquiryList: EnquiryRes[]
}


export const RequirementDetailComponent = (props: RequirementDetailComponentProps) => {
    const { useToken } = theme
    const { token } = useToken()
    const navigate = useNavigate()

    const { enquiry, oldEnquiryList } = props

    const columnList: ColumnsType<EnquiryRes> = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            render: (id) => <Link to={`/enquiry/${id}`} target="_blank" rel="noopener noreferrer">{id.substring(0, 6)}...</Link>,
        },
        {
            title: 'Source',
            dataIndex: 'source',
            key: 'source',
        },
        {
            title: 'Requirement',
            dataIndex: 'requirement',
            render: (requirement) => <div style={{ minWidth: 374, maxWidth: 374 }}><TextEditorView initData={requirement} onChange={() => { }} readOnly={true} /></div>,
        },
        {
            title: 'Owner',
            dataIndex: 'owner',
            key: 'owner',
            render: (owner) => <span>{formatName(owner.assignedTo.name)}</span>,
        },
        {
            title: 'Project Name',
            dataIndex: 'project',
            key: 'project',
            render: (project) => <span>{project?.name}</span>,
        },
        {
            title: 'Next Action',
            dataIndex: 'currentNote',
            key: 'currentNote',
            render: (currentNote) => <span>{currentNote.type}</span>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => <span>{status.value}</span>,
        },
    ];

    return <>
        <React.Fragment>
            <Row className="card-custom-row">
                <PropertyPrefrence enquiry={enquiry} />
                <EnquiryStatus enquiry={enquiry} />

            </Row>
            <Row className="card-custom-row" style={{
                marginTop: '25px',
            }}>

                <LocationPreference enquiry={enquiry} />

            </Row>

        </React.Fragment>


        <Card title="Old Enquiry" bordered={false} style={{ width: '100%', marginTop: token.marginSM }}>
            {isMobile ? <>
                {oldEnquiryList.map((enquiry: EnquiryRes, index: number) => {
                    return <EnquireRowReadItem addLink={false} enquiry={enquiry} lastItem={index == oldEnquiryList.length - 1} />
                })}
            </> : <Table
                columns={columnList} dataSource={oldEnquiryList}
                pagination={false}
                loading={{ indicator: <div><Spin /></div>, spinning: false }} />
            }
        </Card>
    </>
}